import React from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function JobberOverview() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
          <CardDescription>Latest sync activity and updates</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-chart-5 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm font-medium">Customer sync completed</p>
                <p className="text-xs text-muted-foreground">5 minutes ago</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-chart-4 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm font-medium">New job created: Chimney Repair</p>
                <p className="text-xs text-muted-foreground">12 minutes ago</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-accent rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm font-medium">Invoice payment received</p>
                <p className="text-xs text-muted-foreground">25 minutes ago</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Sync Health</CardTitle>
          <CardDescription>Integration performance metrics</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-sm">Overall Health</span>
              <Badge variant="default" className="bg-chart-5/10 text-chart-5">Excellent</Badge>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">Sync Success Rate</span>
              <span className="text-sm font-medium">98.5%</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">Average Sync Time</span>
              <span className="text-sm font-medium">2.3 minutes</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">Last Full Sync</span>
              <span className="text-sm font-medium">6 hours ago</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
